var map = {
	"./": "Lwur",
	"./error-store": "s4xR",
	"./error-store/": "s4xR",
	"./error-store/index": "s4xR",
	"./error-store/index.js": "s4xR",
	"./index": "Lwur",
	"./index.js": "Lwur"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "zZy+";


//////////////////
// WEBPACK FOOTER
// ./src/plugin ^\.\/.*$
// module id = zZy+
// module chunks = 1